import React from "react";
import { FiX, FiDownload, FiExternalLink } from "react-icons/fi";

const InvoicePreview = ({ invoiceData = {}, onClose }) => {
  const pdfUrl = invoiceData?.invoice_url;

  if (!pdfUrl) {
    return (
      <div className="fixed inset-0 z-50 bg-black/60 flex justify-center items-center p-4">
        <div className="bg-white p-6 rounded-lg shadow-xl">
          <p className="text-red-500 font-bold">
            Error: Invoice URL not found.
          </p>
          <button
            onClick={onClose}
            className="mt-4 px-4 py-2 bg-gray-200 rounded"
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex justify-center items-center p-2 sm:p-4">
      <div className="bg-white w-full max-w-5xl h-[95vh] rounded-2xl shadow-2xl overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b bg-white">
          <div>
            <h2 className="text-lg font-bold text-gray-800">
              Invoice: {invoiceData?.invoice_no || "Preview"}
            </h2>
            <p className="text-xs text-gray-500">
              Order ID: {invoiceData?.order_no}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
              title="Open in new tab"
            >
              <FiExternalLink size={20} />
            </a>
            <button
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
            >
              <FiX size={24} />
            </button>
          </div>
        </div>

        {/* PDF Viewer Body */}
        <div className="flex-grow bg-gray-100 relative">
          <iframe
            src={`${pdfUrl}#view=FitH`}
            title="Invoice PDF"
            className="w-full h-full border-none"
          />
        </div>

        {/* Footer Actions */}
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-6 py-2.5 border border-gray-300 rounded-xl text-sm font-bold text-gray-600 hover:bg-white transition-all"
          >
            Close
          </button>
          {/* Use anchor tag to open in new tab (works despite CORS) */}
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-6 py-2.5 bg-green-600 text-white rounded-xl text-sm font-bold hover:bg-green-700 shadow-lg shadow-green-100 transition-all"
          >
            <FiDownload />
            Download PDF
          </a>
        </div>
      </div>
    </div>
  );
};

export default InvoicePreview;
